import { defineStore } from 'pinia';

export const usePdfStore = defineStore('pdf', {
	state: () => ({
		pdfPayload: null,
	}),

	getters: {
		isGeneratingPdf: (state) => state.pdfPayload !== null,
	},

	actions: {
		startPdfDownload(payload) {
			this.pdfPayload = payload;
		},
		clearPdfDownload() {
			this.pdfPayload = null;
		},
		START_PDF_DOWNLOAD(payload) {
			this.startPdfDownload(payload);
		},
		CLEAR_PDF_DOWNLOAD() {
			this.clearPdfDownload();
		},
	},
});

export default usePdfStore;
